import React from 'react'
import './aboutus.css';

function AboutUs() {
  return (
    <div className='aboutus'>
     <div className='container'>
     <h2> India’s Largest and Cheapest Online Bookstore offering 40+ Million selections.</h2>
      <h2>“I declare after all there is no enjoyment like reading!”</h2>
      <h2>- Jane Austen, Pride and Prejudice.</h2>
     </div>
    </div>
  )
}

export default AboutUs;